export const MailData: {
  YOUR_USER_ID: string;
  YOUR_SERVICE_ID: string;
  YOUR_TEMPLATE_ID: string;
} = {
  YOUR_USER_ID: "user_2qMHD333SnGP9mMyRulhg",
  YOUR_SERVICE_ID: "service_hx0f788",
  YOUR_TEMPLATE_ID: "template_flbkuta",
};
